import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Auth from "./layout/firebase/auth";
import "./index.scss";
import Loader from "./layout/layoutcomponent/loaders";
import { Routingdata } from "./common/routingdata";
import Switcher1 from "./components/pages/switcher/switcher1/switcher1";
import * as Sentry from "@sentry/react";

const Login = React.lazy(() => import("./layout/firebase/login"));
const FirebaseSignUp = React.lazy(() => import("./layout/firebase/signup"));
const App = React.lazy(() => import("./layout/App"));
const Switcherapp = React.lazy(() => import("./layout/Switcherapp"));
const Custompages = React.lazy(() => import("./layout/custompages"));
const Dashboard = React.lazy(
  () => import("./components/dashboard/dashboard1/dashboard")
);

const Projects = React.lazy(() => import("./components/projects/projects"));
const Reviews = React.lazy(() => import("./components/reviews/reviews"));
const ArchivedReviews = React.lazy(
  () => import("./components/reviews/archivedreviews")
);
const ReviewDetail = React.lazy(
  () => import("./components/reviews/reviewdetail")
);
const ArchivedProjects = React.lazy(
  () => import("./components/projects/archivedprojects")
);
const Members = React.lazy(() => import("./components/members/members"));
const Communities = React.lazy(
  () => import("./components/communities/communities")
);
const PendingMembers = React.lazy(
  () => import("./components/members/pendingmembers")
);
const ProjectDetail = React.lazy(
  () => import("./components/projects/projectdetail")
);
const Reports = React.lazy(() => import("./components/reports/reports"));

//pages
const SignUp = React.lazy(
  () => import("./components/pages/authentication/signup/signup")
);
const SignIn = React.lazy(
  () => import("./components/pages/authentication/signin/signin")
);
const ForgotPassword = React.lazy(
  () =>
    import("./components/pages/authentication/forgotpassword/forgotpassword")
);
const Lockscreen = React.lazy(
  () => import("./components/pages/authentication/lockscreen/lockscreen")
);
const ResetPassword = React.lazy(
  () => import("./components/pages/authentication/resetpassword/resetpassword")
);
const AcceptInvite = React.lazy(
  () => import("./components/pages/authentication/acceptinvite/acceptinvite")
);
const UnderConstruction = React.lazy(
  () =>
    import(
      "./components/pages/authentication/underconstruction/underconstruction"
    )
);
const Error404 = React.lazy(
  () => import("./components/pages/authentication/404error/404error")
);
const Error500 = React.lazy(
  () => import("./components/pages/authentication/500error/500error")
);

const ThankYou = React.lazy(
  () => import("./components/pages/authentication/thankyou/thankyou")
);
const Unsubscribe = React.lazy(
  () => import("./components/pages/authentication/unsubscribe/unsubscribe")
);
const Landing = React.lazy(
  () => import("./components/landing/landing")
);

Sentry.init({
  dsn: "https://c4d135ca79820608e94db1db53c55309@o4509209169362944.ingest.us.sentry.io/4509209227296768",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

//Form
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.Fragment>
    <BrowserRouter>
      <React.Suspense fallback={<Loader />}>
        <Routes>
          <Route path={`${import.meta.env.BASE_URL}`} element={<Auth />}>
            <Route index element={<Login />} />
            <Route
              path={`${import.meta.env.BASE_URL}login`}
              element={<Login />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}firebase/signup`}
              element={<FirebaseSignUp />}
            />
          </Route>
          <Route path={`${import.meta.env.BASE_URL}`} element={<App />}>
            <Route
              path={`${import.meta.env.BASE_URL}projects`}
              element={<Projects />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}archivedprojects`}
              element={<ArchivedProjects />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}projectdetail/:id`}
              element={<ProjectDetail />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}reviews`}
              element={<Reviews />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}archivedreviews`}
              element={<ArchivedReviews />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}reviewdetail/:id`}
              element={<ReviewDetail />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}members`}
              element={<Members />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}pendingmembers`}
              element={<PendingMembers />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}communities`}
              element={<Communities />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}reports`}
              element={<Reports />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}landing`}
              element={<Landing />}
            />

            {Routingdata.map((idx) => (
              <Route
                path={idx.path}
                element={idx.element}
                key={Math.random()}
              />
            ))}
          </Route>
          <Route path={`${import.meta.env.BASE_URL}`} element={<Custompages />}>
            <Route
              path={`${import.meta.env.BASE_URL}register`}
              element={<SignUp />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}thankyou`}
              element={<ThankYou />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}pages/authentication/sigin`}
              element={<SignIn />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}signup`}
              element={<SignUp />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}forgotpass`}
              element={<ForgotPassword />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}users/unsubscribe/:id`}
              element={<Unsubscribe />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}reset/:token`}
              element={<ResetPassword />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}acceptinvite/:token`}
              element={<AcceptInvite />}
            />
            <Route
              path={`${
                import.meta.env.BASE_URL
              }pages/authentication/lockscreen`}
              element={<Lockscreen />}
            />
            <Route
              path={`${
                import.meta.env.BASE_URL
              }pages/authentication/underconstruction`}
              element={<UnderConstruction />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}pages/authentication/404error`}
              element={<Error404 />}
            />
            <Route
              path={`${import.meta.env.BASE_URL}pages/authentication/500error`}
              element={<Error500 />}
            />

            <Route path="*" element={<Error404 />} />
          </Route>

          <Route path={`${import.meta.env.BASE_URL}`} element={<Switcherapp />}>
            <Route
              path={`${import.meta.env.BASE_URL}pages/switcher/switcher1`}
              element={<Switcher1 />}
            />
          </Route>
          <Route></Route>
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  </React.Fragment>
);
